module.exports = __webpack_public_path__ + "fb7dfaf9ad11782b875f66e54a4fcf83.pdf";